if (!customElements.get("ladder-clearance-offer")) {
  customElements.define(
    "ladder-clearance-offer",
    class LadderClearanceOffer extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector("dialog");
        this.pendingChoice = null;
        this.activeConfiguration = "";
        this.activeDiscountCode = "";
        this.querySelectorAll("[data-ladder-choice]").forEach((button) => {
          button.addEventListener("click", () => this.resolveChoice(button.dataset.ladderChoice));
        });
        this.querySelector("[data-ladder-offer-cancel]")?.addEventListener("click", () => this.resolveChoice(null));
        this.dialog?.addEventListener("cancel", (event) => {
          event.preventDefault();
          this.resolveChoice(null);
        });
        this.dialog?.addEventListener("click", (event) => {
          if (event.target === this.dialog) this.resolveChoice(null);
        });
      }

      choose(variantId) {
        const variantData = this.querySelector(`[data-ladder-variant-data][data-variant-id="${CSS.escape(String(variantId || ""))}"]`);
        this.activeConfiguration = variantData?.dataset.ladderConfiguration || "";
        this.activeDiscountCode = variantData?.dataset.discountCode || "";

        if (!variantData) return Promise.resolve("not-applicable");
        if (this.activeConfiguration === "universal_only") return Promise.resolve("universal");
        if (!this.dialog || this.dialog.open) return Promise.resolve(null);

        this.prepareDialog(variantData);
        return new Promise((resolve) => {
          this.pendingChoice = resolve;
          this.dialog.showModal();
          this.querySelector("[data-ladder-choice]:not([hidden])")?.focus();
        });
      }

      prepareDialog(variantData) {
        const rightHandOnly = this.activeConfiguration === "right_hand_only";
        const title = this.querySelector("[data-ladder-offer-title]");
        const copy = this.querySelector("[data-ladder-offer-copy]");
        const code = this.querySelector("[data-ladder-offer-code]");
        const universalChoice = this.querySelector('[data-ladder-choice="universal"]');
        const rightHandChoice = this.querySelector("[data-ladder-right-hand-choice]");
        const actions = this.querySelector("[data-ladder-offer-actions]");
        const customMessage = variantData.querySelector("[data-ladder-variant-message]");

        if (title) title.textContent = rightHandOnly ? "Right-hand-only ladder" : "Choose your ladder configuration";
        if (code) code.textContent = this.activeDiscountCode;
        if (universalChoice) universalChoice.hidden = rightHandOnly;
        if (rightHandChoice) {
          rightHandChoice.textContent = rightHandOnly
            ? "Continue with right-hand-only ladder — save £10"
            : "Choose right-hand only — save £10";
        }
        actions?.classList.toggle("ladder-clearance-offer__actions--single", rightHandOnly);

        if (copy) {
          copy.replaceChildren();
          if (customMessage?.childNodes.length) {
            [...customMessage.childNodes].forEach((node) => copy.appendChild(node.cloneNode(true)));
          } else {
            this.addParagraph(copy, rightHandOnly
              ? "This bed is supplied with a right-hand-only ladder."
              : "This bed includes a universal ladder that can be fitted on either side.");
            this.addParagraph(copy, rightHandOnly
              ? "Use the code shown below at checkout to save £10."
              : "We also have limited right-hand-only stock available. Choose that version and save £10 using the code below at checkout.");
          }
        }
      }

      addParagraph(container, text) {
        const paragraph = document.createElement("p");
        paragraph.textContent = text;
        container.appendChild(paragraph);
      }

      resolveChoice(choice) {
        if (this.dialog?.open) this.dialog.close();
        const resolve = this.pendingChoice;
        this.pendingChoice = null;
        if (resolve) resolve(choice);
      }

      applyChoice(form, choice) {
        if (choice === "not-applicable") {
          this.setProperty(form, "Ladder configuration", "");
          this.setProperty(form, "Ladder discount code", "");
          return;
        }
        this.setProperty(form, "Ladder configuration", choice === "right-hand" ? "Right-hand only clearance" : "Universal ladder");
        this.setProperty(form, "Ladder discount code", choice === "right-hand" ? this.activeDiscountCode : "");
      }

      setProperty(form, name, value) {
        const selector = `input[data-ladder-property="${CSS.escape(name)}"]`;
        let input = form.querySelector(selector);
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = `properties[${name}]`;
          input.dataset.ladderProperty = name;
          form.appendChild(input);
        }
        input.value = value;
        input.disabled = value === "";
      }
    }
  );
}
